import { Input } from './ui/input';
import { Check, AlertCircle } from 'lucide-react';

const EMAIL_RX = /^\S+@\S+\.\S+$/;

const EmailInput = ({ id, value, onChange, dataTestId, autoComplete = 'email', name = 'email', placeholder }) => {
  const trimmed = (value || '').trim();
  const hasInput = trimmed.length > 0;
  const valid = EMAIL_RX.test(trimmed);

  return (
    <div className="space-y-1.5" data-testid={`${dataTestId || id}-wrapper`}>
      <div className="relative">
        <Input
          id={id}
          name={name}
          type="email"
          inputMode="email"
          autoComplete={autoComplete}
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck="false"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required
          className="bg-[#0A0A0A] border-[#27272A] focus:ring-[#8B5CF6] pr-10"
          data-testid={dataTestId}
        />
        {hasInput && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
            {valid ? (
              <Check className="w-5 h-5 text-[#10B981]" data-testid={`${dataTestId || id}-valid-icon`} />
            ) : (
              <AlertCircle className="w-5 h-5 text-[#D4AF37]" data-testid={`${dataTestId || id}-pending-icon`} />
            )}
          </div>
        )}
      </div>
      {hasInput && (
        valid ? (
          <p className="text-xs text-[#10B981]" data-testid={`${dataTestId || id}-hint`}>
            Looks good.
          </p>
        ) : (
          <p className="text-xs text-[#D4AF37]" data-testid={`${dataTestId || id}-hint`}>
            Almost there — include the part after the @ (like gmail.com).
          </p>
        )
      )}
    </div>
  );
};

export default EmailInput;
